const createQuery = () => `
  ... on CompanyLatestPostsWidget {
    id
    companyLatestPosts {
      _id
      headline
      fullUrlPath
      contentType
      subContentType
      sell
      images {
        thumbnail_widescreen_553 {
          url
        }
      }
    }
  }
`

export default createQuery
